import ResourceAdmin from "@/components/admin/ResourceAdmin";
import { absoluteUrl } from "@/lib/adminApi";

const emptyItem = {
  slug: "", title_ar: "", short_desc_ar: "", long_desc_ar: "",
  sections: [], features: [], icon: "shield", hero_image: "",
  order: 0, is_active: true,
};

export default function ServicesAdmin() {
  return (
    <ResourceAdmin
      title="الخدمات"
      resource="services"
      testIdPrefix="admin-services"
      emptyItem={emptyItem}
      columns={[
        {
          key: "hero_image", label: "الصورة",
          render: (r) => r.hero_image ? <img src={absoluteUrl(r.hero_image)} alt="" className="w-12 h-12 rounded-lg object-cover" /> : <div className="w-12 h-12 rounded-lg bg-slate-100" />,
        },
        { key: "title_ar", label: "الاسم" },
        { key: "slug", label: "المعرّف" },
        { key: "order", label: "الترتيب" },
        {
          key: "is_active", label: "الحالة",
          render: (r) => (
            <span className={`px-2 py-0.5 rounded-full text-[11px] font-semibold ${r.is_active ? "bg-emerald-100 text-emerald-700" : "bg-slate-200 text-slate-600"}`}>
              {r.is_active ? "مفعّل" : "معطّل"}
            </span>
          ),
        },
      ]}
      fields={[
        { name: "title_ar", label: "اسم الخدمة", type: "text" },
        { name: "slug", label: "المعرّف (slug)", type: "text", ltr: true },
        { name: "short_desc_ar", label: "وصف مختصر", type: "textarea", rows: 2 },
        { name: "long_desc_ar", label: "وصف كامل", type: "textarea", rows: 4 },
        {
          name: "sections", label: "الأقسام (تفاصيل الصفحة)", type: "kv-list",
          keys: ["title_ar", "body_ar"],
          placeholders: { title_ar: "عنوان القسم", body_ar: "نص القسم" },
        },
        { name: "features", label: "المزايا (bullet points)", type: "list" },
        { name: "icon", label: "الأيقونة (lucide)", type: "text", ltr: true, help: "مثل: camera, shield-alert, flame, network" },
        { name: "hero_image", label: "صورة الخدمة", type: "image" },
        { name: "order", label: "الترتيب", type: "number", min: 0 },
        { name: "is_active", label: "مفعّل", type: "checkbox" },
      ]}
    />
  );
}
